module.exports = function createCanvasBrowser () {
  return document.createElement('canvas');
};
